// Bathroom sub feature
export interface FSBathroomSubFeature {
    id: number;
    bathroom_feature_id: number;
    sub_feature_name: string;
    image_path: string | null;
    status: 1 | 0;
    created_by?: number | null;
}

export const mapFSBathroomSubFeature = (data: any): FSBathroomSubFeature => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSBathroomSubFeature = {
        id: data.id,
        bathroom_feature_id: data.bathroom_feature_id,
        sub_feature_name: data.sub_feature_name,
        image_path: data.image_path || null,
        status: data.status,
        created_by: data.created_by || null,
    };

    return res;
};

export const mapFSBathroomSubFeatures = (data: any[]): FSBathroomSubFeature[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSBathroomSubFeature);
};